import { doc, setDoc, getDoc, serverTimestamp, updateDoc, deleteField } from 'firebase/firestore';
import { db } from '../firebase';
const userRef = (uid) => doc(db, 'users', uid);
const cache = {
  // uid -> Set(popupId)
  sets: new Map(),
  stamp: new Map(),
};

function getSet(uid) {
  const key = String(uid||'');
  let s = cache.sets.get(key);
  if (!s) { s = new Set(); cache.sets.set(key, s); }
  return s;
}

function markStamp(uid) {
  cache.stamp.set(String(uid||''), Date.now());
}

function isFresh(uid, maxAgeMs = 15000) { // 15s fresh cache
  const t = cache.stamp.get(String(uid||'')) || 0;
  return Date.now() - t < maxAgeMs;
}

export async function getAll(uid) {
  if (!uid) return [];
  if (!isFresh(uid)) {
    const d = await getDoc(userRef(uid));
    const data = d.exists() ? (d.data() || {}) : {};
    const wl = data.watchlist || {};
    const s = getSet(uid); s.clear();
    for (const k of Object.keys(wl)) s.add(String(k));
    markStamp(uid);
  }
  const s = getSet(uid);
  return Array.from(s).map(k => ({ id: k, popupId: k }));
}

export async function isIn(uid, popupId) {
  if (!uid || !popupId) return false;
  if (!isFresh(uid)) await getAll(uid);
  const s = getSet(uid);
  return s.has(String(popupId));
}

export async function add(uid, item) {
  if (!uid || !item || !item.popupId) return;
  const ref = userRef(uid);
  const path = `watchlist.${String(item.popupId)}`;
  const payload = { ...item, addedAt: serverTimestamp() };
  try {
    await updateDoc(ref, { [path]: payload });
  } catch (e) {
    // if user doc missing, create with nested object structure
    await setDoc(ref, { watchlist: { [String(item.popupId)]: payload } }, { merge: true });
  }
  // update cache immediately
  getSet(uid).add(String(item.popupId));
  markStamp(uid);
  try { window.dispatchEvent(new CustomEvent('watchlist:changed', { detail: { popupId: String(item.popupId), action: 'add' } })); } catch {}
}

export async function remove(uid, popupId) {
  if (!uid || !popupId) return;
  const ref = userRef(uid);
  const path = `watchlist.${String(popupId)}`;
  await updateDoc(ref, { [path]: deleteField() });
  // update cache immediately
  getSet(uid).delete(String(popupId));
  markStamp(uid);
  try { window.dispatchEvent(new CustomEvent('watchlist:changed', { detail: { popupId: String(popupId), action: 'remove' } })); } catch {}
}
